import config from 'config';
import { renderAddress } from 'utils/renderAddress';

export const duplicateEinEmail = (formValues: any) => {
  const emailBody = encodeURIComponent(`Dear Nonprofit Support Team,

I am attempting to register an organization with the EIN "${
    formValues.ein
  }" on your platform, but it appears the organization already exists in the system and is currently invisible. I would like assistance in claiming or updating the organization's profile.

Organization details:

- Name of organization: ${formValues.nonprofitName}
- Legal entity (the name associated with the EIN provided)
- EIN (Employer identification number): ${formValues.ein}
- Address: ${renderAddress(formValues.locationObject)}
- Name of primary contact (official representative)
- Phone number of primary contact
- Email of primary contact (this will be the email used to log in to Deed)
- Role at the organization

Required documents:

Attached please find the following documents:

- Form 4076c from the IRS.
- Letter of association if my organization is a department of the legal entity listed above
- Bank statement, canceled check, or bank letter:  (copy of a bank statement, canceled check, or a bank letter dated within the last two years, which includes our organization's name, tax ID, and full account number)


Please let me know how I can proceed.

Thank you for your support.

Best regards,
[Your Name]
[Your Role/Position]
[Your Organization]
[Your Contact Information]
`);
  const mailtoLink = `mailto:${config.nonprofitSuccessTeamEmail}?subject=Assistance Required for EIN Registration - Organization Already Exists&body=${emailBody}`;

  const newTab = window.open('', '_blank');
  if (newTab) {
    newTab.location.href = mailtoLink;
  }
};
